// @flow

import * as React from 'react';
import CircleButton from 'app/components/buttons/CircleButton';
import Icon from 'app/components/commons/Icon';

type Props = {
  selected?: boolean,
  onClick?: () => void
};

const RadioTick = ({ onClick, selected }: Props) => (
  <CircleButton kind={selected ? 'success' : 'white'} onClick={onClick}>
    {selected && <Icon type="icon-tick" />}
  </CircleButton>
);

RadioTick.defaultProps = {
  selected: false,
  onClick: undefined
};

export default RadioTick;
